import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hotels } from "../config/hotels";
import { setHotelConfiguration } from "../helpers/hotels";
import { GTMTrackingSelectCity } from "../helpers/GTMTracking";
import { useTranslation } from "react-i18next";
import type { IHotelState } from "../features/hotel/hotelInterface";

function SelectHotel() {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [selectedHotel, setSelectedHotel] = useState<IHotelState['HotelCode']>("");



  const getSelectedHotel = (HotelCode: string) => {
    
    setSelectedHotel(HotelCode);

    const fetchConfig = async () => {
      return await setHotelConfiguration({ HotelCode: HotelCode });
    };

    fetchConfig().then(() => {

      // GTM DATALAYER
      GTMTrackingSelectCity();
      // END GTM DATALAYER

      // Navigate to the calendar after a short delay to allow state to update
      setTimeout(() => {
        navigate("/calendar");
      }, 500);

    });
  };

  return (
    <section className={`flex items-end justify-start p-6 h-dvh w-full`}>
      <div className="text-fluid-h2 leading-none">
        <p className="text-fluid-h3 mb-4">{t('scenes.selectHotel.chooseCity')}</p>
        <div className="grid grid-cols-1 gap-4 ">
          {hotels.map((hotel) => (
            <div
              className={`cursor-pointer ${selectedHotel === hotel.HotelCode ? 'animate-pulse' : ''}`}
              onClick={() => getSelectedHotel(hotel.HotelCode)}
              key={hotel.HotelCode}
            >
              <span>{hotel.Name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SelectHotel;
